module.exports = __webpack_public_path__ + "static/media/icons_Bilan Tendinopathie (Membres sup‚rieurs).360512e1.svg";